import React, { useCallback, useEffect, useState } from "react";
import { styled, useTheme, Theme, CSSObject } from '@mui/material/styles';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import { useWalletModal, WalletMultiButton } from '@solana/wallet-adapter-react-ui';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { useTranslation } from 'react-i18next'
import ReactCountryFlag from "react-country-flag"
let cookieCutter = require('cookie-cutter');
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import MenuIcon from '@mui/icons-material/Menu';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import Menu from '@mui/material/Menu';
import LocaleChanger from '../LocaleChanger';
import MainMenu from "../Menu/main";
import CommunityMenu from "../Menu/community";
import { useWallet } from '@solana/wallet-adapter-react';
import Link from "next/link";
import ArrowUnderMenu from "../ArrowUnderMenu";
import AboutUsMenu from "../Menu/aboutUs";
import WalletConnectionProvider from "../WalletConnectionProvider";
import { facade } from "../../helpers/analytic/AnalyticFacade";
import { signUp } from '../../commands/user/signUp';
import { bs58 } from '@project-serum/anchor/dist/cjs/utils/bytes';
import useSession from "../SessionHook/SessionHook";
//
const drawerWidth = 240;

interface AppBarProps extends MuiAppBarProps {
    open?: boolean;
}

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
    zIndex: 1001, //theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        [theme.breakpoints.down('sm')]: { // For small screens!
            width: "100%"
        }
    })
}));

//
const MyToolbar = styled(Toolbar)({
    //paddingLeft: "75px !important"
});

//
export default function AppBarTop(props: any) {
    const theme = useTheme();
    const showMenuText = useMediaQuery(theme.breakpoints.up(1210)); // lower then 600px!
    const { wallets, wallet: selected, publicKey, signMessage, connected } = useWallet();
    const DEV = false;
    const { setVisible } = useWalletModal();
    const { t } = useTranslation();
    const [anchorEl, setAnchorEl] = useState<undefined | HTMLElement>(undefined);
    const openCommMenu = Boolean(anchorEl);
    const { hasSession, updateToken, getTBUid } = useSession();

    //
    const handleClick = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = (e: any, comm: string) => {
        if (props.socialUrls[comm]) {
            window.open(props.socialUrls[comm], "_blank");
        }

        setAnchorEl(undefined);
        e.stopPropagation();
    };

    const handleMainMenuClose = (e: any, page: string) => {
        props.handleMainMenuChange(e, page);
        setAnchorEl(undefined);
        e.stopPropagation();
    };

    // About us menu!
    const [anchorElAboutUs, setAnchorElAboutUs] = useState<undefined | HTMLElement>(undefined);

    //
    const handleClickAboutUs = (event: any) => {
        setAnchorElAboutUs(event.currentTarget);
    };

    const handleCloseAboutUs = (e: any, comm: string) => {
        setAnchorElAboutUs(undefined);
        e.stopPropagation();
    };


    useEffect(() => {
        // Load quests from LS first - just in case!

        // setToken("ttttt");
        // if (!hasSession()) {
        if (publicKey) {
            const base58 = publicKey.toBase58();
            const keyToDisplay =
                base58.length > 20
                    ? `${base58.substring(0, 7)}.....${base58.substring(
                        base58.length - 7,
                        base58.length,
                    )}`
                    : base58;


            facade.setUserAddress(base58);

            //  setKey(keyToDisplay)
            if (signMessage) {

                const encodedMessage = new TextEncoder().encode("Welcome to Eternal Dragons");

                signMessage(encodedMessage).then(signature => {
                    signUp(base58, bs58.encode(signature)).then(res => {
                        console.log("update Quest", res)
                        // saveWalletAddress(publicKey);

                        if (res.token)
                            updateToken(res.token);

                    });
                }).catch(e => {
                    console.log(e);
                });

            }

            // }
        }

    }, [publicKey, signMessage]);



    //
    return (

        <AppBar position="fixed" open={props.openDrawer} sx={{ background: "#262626e5" }}>
            <MyToolbar sx={{ width: "100%", justifyContent: "space-between" }}>

                <Link href="/">
                    <img alt="eternal dragons logo white" src="/Eternal Dragons Logo Lowres White.png" style={{ height: "35px", cursor: "pointer" }} />
                </Link>

                <Box sx={{ display: "flex", alignItems: "center" }}>
                    {showMenuText &&
                        <>
                            <Link href="/whitepaper" passHref>
                                <Box className="top-bar-right-menu-text">
                                    {t("menu.whitepaper")}
                                </Box>
                            </Link>

                            <Box sx={{ position: "relative", color: anchorElAboutUs !== undefined ? "#fddc89" : "" }} className="top-bar-right-menu-text" onClick={handleClickAboutUs}>
                                About Us
                                <ArrowUnderMenu open={anchorElAboutUs !== undefined} sx={{ padding: "0px", position: "absolute", left: '43px', top: "21px" }} />
                                <AboutUsMenu horizontal={10} anchorEl={anchorElAboutUs} open={anchorElAboutUs !== undefined} handleClose={handleCloseAboutUs} />
                            </Box>

                            <Box sx={{ position: "relative", color: openCommMenu ? "#fddc89" : "" }} className="top-bar-right-menu-text" onClick={handleClick} >
                                {t("menu.community")}
                                <ArrowUnderMenu open={openCommMenu} sx={{ padding: "0px", position: "absolute", left: '43px', top: "21px" }} />
                                <CommunityMenu horizontal={10} anchorEl={anchorEl} open={openCommMenu} handleClose={handleClose} socialUrls={props.socialUrls} />
                            </Box>

                            {connected && DEV && <Box onClick={(e) => props.handleMainMenuChange(e, "candy_machine")} className="top-bar-right-menu-text">{t("menu.mint_nft")}</Box>}
                            {connected && DEV && <Box onClick={(e) => props.handleMainMenuChange(e, "inventory")} className="top-bar-right-menu-text">{t("menu.inventory")}</Box>}
                            {connected && DEV && <Box onClick={(e) => props.handleMainMenuChange(e, "dashboard")} className="top-bar-right-menu-text">{t("menu.dashboard")}</Box>}

                            {<a target="_blank" rel="noreferrer" href="https://magiceden.io/marketplace/eternal_dragons_genesis" ><Box sx={{}} className="top-bar-right-menu-text">Marketplace</Box></a>}
                            {<Link href="/mygallery" passHref><Box onClick={(e) => props.handleMainMenuChange(e, "my_gallery")} className="top-bar-right-menu-text">Gallery</Box></Link>}
                            {<Link href="/ranking" passHref><Box sx={{ marginRight: "10px" }} onClick={(e) => props.handleMainMenuChange(e, "ranking")} className="top-bar-right-menu-text">Ranking</Box></Link>}
                            {/* <Link href="/inventory" passHref><Box sx={{marginRight: "10px"}} onClick={(e) => props.handleMainMenuChange(e, "dashboard")} className="top-bar-right-menu-text">Inventory</Box></Link> */}
                        </>}

                    {!showMenuText &&
                        <>
                            <MenuIcon onClick={handleClick} sx={{ color: "white", fontSize: "33px", cursor: "pointer", marginRight: "10px" }} />
                            <MainMenu menuOpts={props.menuOpts} anchorEl={anchorEl} open={openCommMenu} handleClose={handleMainMenuClose} socialUrls={props.socialUrls} />
                        </>
                    }

                    {/* Change UI language */}
                    {showMenuText && DEV && <LocaleChanger siteLang={props.siteLang} mystyle={{ margin: "0px 20px 0px 15px" }} />}

                    {/* Wallet button */}
                    {
                        <WalletMultiButton className={"special " + (hasSession() ? "none" : "")} style={{ float: "right" }} />
                    }

                    {hasSession() &&


                        <Box sx={{ position: "relative", color: anchorElAboutUs !== undefined ? "#fddc89" : "" }} className="top-bar-right-menu-text">

                            <Link href="/profile" passHref><Box onClick={(e) => props.handleMainMenuChange(e, "profile")} className="top-bar-right-menu-text">Profile</Box></Link>

                        </Box>
                    }

                </Box>


            </MyToolbar>
        </AppBar>

    );
}
